<template>
  <custom-callout
    :border-color="statusColor.color"
    class-main="mt-3 rounded"
    :has-toggle="false"
  >
    <div class="row py-2 mr-md-0 align-items-center">
      <div class="col col-lg-2 col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Tipo de Lugar:</div>
        <div class="color-black font-16">
          {{ data.locationTypeName | empty }}
        </div>
      </div>
      <div id="col-lg-2" class="col col-lg-1 col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Municipio:</div>
        <div class="color-black font-16">
          {{ data.municipalityName | empty }}
        </div>
      </div>
      <div class="col col-lg-2 col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Lugar de Servicio:</div>
        <div class="color-black font-16">
          {{ data.locationName | empty }}
        </div>
      </div>
      <div class="col col-lg-2 col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Teléfono:</div>
        <div class="color-black font-16">
          {{ data.locationTelephoneNo | phone }}
        </div>
      </div>
      <div class="col col-lg-1 col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Estatus:</div>
        <div class="color-black font-16">
          <span class="circle-dot mr-2" :style="`${statusColor.badged}`" />
          {{ statusName | empty }}
        </div>
      </div>
      <div
        class="col-lg-3 col-12 d-flex align-items-center justify-content-center"
      >
        <certification-badge
          v-if="
            data.isCertified !== null && isMedicaidDocumentationWorkflowEnabled
          "
          text="Certificada"
          :value="data.isCertified"
        />
      </div>
      <div
        class="
          col col-lg-1 col-12
          d-flex
          align-items-center
          justify-content-end
        "
      >
        <action-button
          class="button-action-size"
          i="fas fa-file-import"
          text="Entrar"
          variant="outline-success m-2 px-4"
          @click="$emit('on-view-location-service')"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ServiceStatusColors from '@/utils/constants/requestServiceStatusColors';
import LocationServiceState from '@/utils/constants/locationServiceState.js';
import ActionButton from 'ActionButton';
import CertificationBadge from './CertificationBadge.vue';

export default {
  name: 'LocationServiceResultRow',
  components: {
    CustomCallout,
    ActionButton,
    CertificationBadge,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    isMedicaidDocumentationWorkflowEnabled: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    statusColor() {
      switch (this.data.status) {
        case LocationServiceState.Inactive:
          return {
            color: ServiceStatusColors.Yellow,
            badged: 'background-color: #f8ea80',
          };
        case LocationServiceState.Active:
          return {
            color: ServiceStatusColors.GreenLight,
            badged: 'background-color: #A3E5B3',
          };
        default:
          return null;
      }
    },
    statusName() {
      return this.data.status == LocationServiceState.Inactive
        ? 'Inactivo'
        : 'Activo';
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.circle-dot {
  height: 7px;
  width: 7px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
.button-action-size {
  width: 125px;
  height: 36px;
  background-color: map-get($colors, 'secondary-3') !important;
}
.button-action-size:hover {
  background-color: map-get($colors, 'green') !important;
}

//button size mobile
@media (max-width: 576px) {
  .button-action-size {
    width: 100%;
    height: 36px;
    background-color: map-get($colors, 'secondary-3') !important;
  }
  #col-municipality {
    margin-left: 0 !important;
  }
}
</style>
